import React from "react";

export default function Card(props) {
    let style = props.selected ? "card selected" : "card"  
    style = props.held ? "card held" : style
    return (
        <div className={style} onClick={props.clickHandler}>
              <p>
                {props.value}
              </p>
             </div>
    )
}